import { Button, ButtonGroup, ListItem, ListItemIcon } from '@mui/material'
import { FormatAlignCenter, FormatAlignLeft, FormatAlignRight } from '@tunasong/icons'
import { isAlignable } from '@tunasong/models'
import type { Alignment } from '@tunasong/models'
import { isCoreElement } from '@tunasong/schemas'
import { useCallback } from 'react'
import type { FC } from 'react'
import invariant from 'tiny-invariant'
import { EditorQueries, useEditor } from '@tunasong/plugin-lib'
import type { RenderMenuItemProps } from '@tunasong/plugin-lib'

export const AlignAction: FC<RenderMenuItemProps> = props => {
  const { element, onClose } = props
  const editor = useEditor({ allowNull: true })

  const handleAlign = useCallback(
    (align: Alignment) => () => {
      invariant(editor, `Editor is not set`)
      invariant(isCoreElement(element), `Element is not a core element`)
      invariant(isAlignable(element), `Element is not alignable`)
      EditorQueries.updateElement(editor, element, {
        align,
      })
    },
    [editor, element]
  )

  if (!editor || !isAlignable(element)) {
    return null
  }

  const { align } = element

  return (
    <ListItem onClick={onClose}>
      <ListItemIcon>{<FormatAlignCenter />}</ListItemIcon>
      <ButtonGroup size="small">
        <Button disabled={align === 'left'} onClick={handleAlign('left')}>
          <FormatAlignLeft />
        </Button>
        <Button disabled={align === 'center'} onClick={handleAlign('center')}>
          <FormatAlignCenter />
        </Button>
        <Button disabled={align === 'right'} onClick={handleAlign('right')}>
          <FormatAlignRight />
        </Button>
      </ButtonGroup>
    </ListItem>
  )
}

export default AlignAction
